import axios from 'axios'
import config from '../../../utils/config'

const service = axios.create({
  baseURL: config.baseUrl,
  timeout: 40000,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/json; charset=UTF-8'
  }
})
service.interceptors.request.use(
  config => {
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data
    return res
  },
  error => {
    return Promise.reject(error)
  }
)
export default service



// WEBPACK FOOTER //
// ./src/components/verifition/utils/axios.js